import {IconBoxWrapProps} from "@FRAMEWORK/ui/types/d";
import styled from "styled-components";
import imgButton from "@PUBLIC/P/images/btn/btn_spr.png";
import SearchIcon from "@FRAMEWORK/ui/desktop/icon/SearchIcon";

const FilterHeader = styled.div`
	display: flex;
	width: 100%;
	min-height: 60px;
	padding: 10px 0;
	border-bottom: 1px solid var(--line-color);
	background-color: #fff;
	box-sizing: border-box;
	align-items: center;
	justify-content: space-between;
`;

const FilterTag = styled.button`
	position: relative;
	display: flex;
	margin-right: 10px;
	background-color: transparent;
	color: var(--default-color);
	align-items: center;
	line-height: 1;

	i {
		display: block;
		position: relative;
		width: 12px;
		height: 12px;
		margin-left: 5px;
		font-size: 0;

		&::before,
		&::after {
			position: absolute;
			top: 50%;
			left: 0;
			right: 0;
			height: 1px;
			background: #7c7c7c;
			transform: translateY(-50%);
			content: "";
		}

		&::before {
			transform: rotate(45deg);
		}

		&::after {
			transform: rotate(-45deg);
		}
	}
`;

const FilterTagWrap = styled.ul`
	position: relative;
	display: flex;
	padding-left: 10px;
	margin-left: 10px;
	align-items: center;
	flex-wrap: wrap;
	gap: 5px;

	&::before {
		position: absolute;
		left: 0;
		top: 50%;
		display: block;
		width: 1px;
		height: 13px;
		background-color: var(--line-color);
		transform: translateY(-50%);
		content: "";
	}

	li {
		display: flex;
	}
`;

const FloatingContent = styled.div`
	position: relative;
`;

const FloatingWrap = styled.div`
	position: sticky;
	width: 240px;
`;

const OptionItem = styled.li<{width?: string}>`
	height: 100%;
	border-bottom: 1px solid var(--line-color);
	cursor: pointer;

	&:last-child {
		border-bottom: none;
	}

	input[type="checkbox"] {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip: rect(0, 0, 0, 0);
		border: 0;
	}

	label {
		display: block;
		height: 38px;
		color: var(--default-color);
		line-height: 38px;
		text-overflow: ellipsis;
		white-space: nowrap;
		overflow: hidden;
	}

	input[type="checkbox"]:checked + label {
		color: var(--emp-color);
		background-color: var(--yellow-color);
	}

	span {
		display: flex;
		height: 100%;
		align-items: center;
		justify-content: center;
		color: var(--bl-color);
		cursor: auto;
	}

	${props =>
		props.width &&
		`
        border-bottom: none;
        border-right: 1px solid var(--line-color);
        flex: 1 1 ${props.width};
        justify-content: center;

        &:last-child {
            border-right: none;
        }

        > label {
            padding-left: 0;
            justify-content: center;
            text-align: center;
        }
    `}
`;

const OptionList = styled.ul<{direction?: string; height?: string}>`
	display: flex;
	max-height: ${props => props.height || "195px"};
	margin-bottom: 20px;
	border: 1px solid var(--line-color);
	flex-direction: ${props => props.direction || "column"};
	overflow-y: auto;

	label {
		padding-left: 10px;
	}
`;

const GridList = styled.ul<{columns?: string}>`
	display: grid;
	margin: 0 1px;
	grid-template-columns: ${props => props.columns};
	grid-gap: 1px;

	li {
		border: none;
		outline: 1px solid var(--line-color);
		text-align: center;
	}
`;

const OptionTextField = styled.div`
	display: flex;
	margin-bottom: 20px;
	gap: 5px;
	align-items: center;

	input {
		width: 100%;
		text-align: right;
	}
`;

const OptionTitle = styled.h3<{active: boolean}>`
	position: relative;
	padding: 20px 0;
	border-top: 1px solid var(--line-color);
	font-size: var(--default-size);
	color: var(--emp-color);
	line-height: 1;
	cursor: pointer;

	&::before {
		position: absolute;
		right: 0;
		top: 50%;
		width: 10px;
		height: 2px;
		background-color: var(--emp-color);
		transform: translateY(-50%);
		content: "";
	}

	&::after {
		position: absolute;
		right: 4px;
		top: 50%;
		width: 2px;
		height: 10px;
		background-color: var(--emp-color);
		transform: translateY(-50%);
		content: "";
	}

	${props =>
		props.active &&
		`
        &::after {
            display: none;
        }
    `}
`;

const OptionWrap = styled.div<{show: string}>`
	height: 0;
	display: none;

	${props =>
		props.show &&
		`
        height: auto;
        display: block;
    `}
`;

const RatingHeader = styled.div`
	display: flex;
	width: 100%;
	height: 80px;
	background-color: #fff;
	align-items: center;
	justify-content: space-between;
`;

const Search = styled.div`
	display: flex;
	background-color: #fff;
	border: 1px solid var(--line-color);
	align-items: center;

	input {
		width: 204px;
		height: 38px;
		padding: 0 0 0 9px;
		border: none;

		&::palceholder {
			color: var(--gray-color);
		}
	}

	button {
		width: 16px;
		height: 15px;
		margin: 0 9px;
		background: url(${imgButton}) 0px 0px / 93px 40px;
	}
`;

const SearchWrap = styled.div`
	padding: 20px 0;
`;

const IconBoxWrap = styled.div`
	display: flex;
	height: 40px;
	padding: 0 10px;
	align-items: center;
	border: 1px solid var(--line-color);
	box-sizing: border-box;
	background-color: #fff;

	span {
		margin-left: 8px;
		font-family: "pr-font-medium";
		color: var(--blue-color);
	}
`;

const IconBox = ({...props}: IconBoxWrapProps) => (
	<IconBoxWrap onClick={props?.onClick}>
		<SearchIcon {...props} />
		<div dangerouslySetInnerHTML={{__html: props.innerHtml}}></div>
	</IconBoxWrap>
);

export {
	FilterHeader,
	FilterTag,
	FilterTagWrap,
	FloatingContent,
	FloatingWrap,
	OptionItem,
	OptionList,
	OptionTextField,
	OptionTitle,
	OptionWrap,
	RatingHeader,
	Search,
	SearchWrap,
	IconBox,
	GridList,
};
